import { Flex, Tag } from "antd";

const Tags = ({ tags }) => {
  return (
    <Flex wrap="wrap">
      {tags.map((tag) => {
        return (
          <Tag className="mt-2 rounded-full" color={tag.color} key={tag.id}>
            {tag.name}
          </Tag>
        );
      }, [])}
    </Flex>
  );
};

export default Tags;
